export const extendedColors = {
  deepPurple: {
    50: '#f5f3ff',
    100: '#ede9fe',
    200: '#ddd6fe',
    300: '#c4b5fd',
    400: '#a78bfa',
    500: '#8b5cf6',
    600: '#7c3aed',
    700: '#6d28d9',
    800: '#5b21b6',
    900: '#4c1d95',
    A100: '#b388ff',
    A200: '#7c4dff',
    A400: '#651fff',
    A700: '#6200ea',
  },
  indigo: {
    50: '#eef2ff',
    100: '#e0e7ff',
    200: '#c7d2fe',
    300: '#a5b4fc',
    400: '#818cf8',
    500: '#6366f1',
    600: '#4f46e5',
    700: '#4338ca',
    800: '#3730a3',
    900: '#312e81',
    A100: '#8c9eff',
    A200: '#536dfe',
    A400: '#3d5afe',
    A700: '#304ffe',
  },
  lightBlue: {
    50: '#f0f9ff',
    100: '#e0f2fe',
    200: '#bae6fd',
    300: '#7dd3fc',
    400: '#38bdf8',
    500: '#0ea5e9',
    600: '#0284c7',
    700: '#0369a1',
    800: '#075985',
    900: '#0c4a6e',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea',
  },
  cyan: {
    50: '#ecfeff',
    100: '#cffafe',
    200: '#a5f3fc',
    300: '#67e8f9',
    400: '#22d3ee',
    500: '#06b6d4',
    600: '#0891b2',
    700: '#0e7490',
    800: '#155e75',
    900: '#164e63',
    A100: '#67e8f9',
    A200: '#22d3ee',
    A400: '#06b6d4',
    A700: '#0891b2',
  },
  teal: {
    50: '#f0fdfa',
    100: '#ccfbf1',
    200: '#99f6e4',
    300: '#5eead4',
    400: '#2dd4bf',
    500: '#14b8a6',
    600: '#0d9488',
    700: '#0f766e',
    800: '#115e59',
    900: '#134e4a',
    A100: '#5eead4',
    A200: '#2dd4bf',
    A400: '#14b8a6',
    A700: '#0d9488',
  },
  lightGreen: {
    50: '#f7fee7',
    100: '#ecfccb',
    200: '#d9f99d',
    300: '#bef264',
    400: '#a3e635',
    500: '#84cc16',
    600: '#65a30d',
    700: '#4d7c0f',
    800: '#3f6212',
    900: '#365314',
    A100: '#bef264',
    A200: '#a3e635',
    A400: '#84cc16',
    A700: '#65a30d',
  },
  amber: {
    50: '#fffbeb',
    100: '#fef3c7',
    200: '#fde68a',
    300: '#fcd34d',
    400: '#fbbf24',
    500: '#f59e0b',
    600: '#d97706',
    700: '#b45309',
    800: '#92400e',
    900: '#78350f',
    A100: '#fcd34d',
    A200: '#fbbf24',
    A400: '#f59e0b',
    A700: '#d97706',
  },
  deepOrange: {
    50: '#fff6f4',
    100: '#ffede8',
    200: '#ffd4ca',
    300: '#ffb4a1',
    400: '#ff8a6f',
    500: '#ff5733',
    600: '#f44819',
    700: '#d93815',
    800: '#b82d11',
    900: '#96240d',
    A100: '#ff9f8d',
    A200: '#ff7a61',
    A400: '#ff4f1f',
    A700: '#f43600',
  },
  brown: {
    50: '#fbf5f1',
    100: '#f5e9e2',
    200: '#e8d2c5',
    300: '#d7b7a3',
    400: '#c49881',
    500: '#ab7761',
    600: '#8f5e4a',
    700: '#744937',
    800: '#5d3726',
    900: '#482718',
    A100: '#d7b7a3',
    A200: '#c49881',
    A400: '#ab7761',
    A700: '#8f5e4a',
  },
  blueGrey: {
    50: '#f8fafc',
    100: '#f1f5f9',
    200: '#e2e8f0',
    300: '#cbd5e1',
    400: '#94a3b8',
    500: '#64748b',
    600: '#475569',
    700: '#334155',
    800: '#1e293b',
    900: '#0f172a',
    A100: '#cbd5e1',
    A200: '#94a3b8',
    A400: '#64748b',
    A700: '#475569',
  },
  pink: {
    50: '#FDF2F8',
    100: '#FCE7F3',
    200: '#FBCFE8',
    300: '#F9A8D4',
    400: '#F472B6',
    500: '#EC4899',
    600: '#DB2777',
    700: '#BE185D',
    800: '#9D174D',
    900: '#831843',
    A100: '#FF80AB',
    A200: '#FF4081',
    A400: '#F50057',
    A700: '#C51162',
  },
  blue: {
    50: '#EFF6FF',
    100: '#DBEAFE',
    200: '#BFDBFE',
    300: '#93C5FD',
    400: '#60A5FA',
    500: '#3B82F6',
    600: '#2563EB',
    700: '#1D4ED8',
    800: '#1E40AF',
    900: '#1E3A8A',
    A100: '#82B1FF',
    A200: '#448AFF',
    A400: '#2979FF',
    A700: '#2962FF',
  },
  green: {
    50: '#F0FDF4',
    100: '#DCFCE7',
    200: '#BBF7D0',
    300: '#86EFAC',
    400: '#4ADE80',
    500: '#22C55E',
    600: '#16A34A',
    700: '#15803D',
    800: '#166534',
    900: '#14532D',
    A100: '#B9F6CA',
    A200: '#69F0AE',
    A400: '#00E676',
    A700: '#00C853',
  },
  grey: {
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#E5E5E5',
    300: '#D4D4D4',
    400: '#A3A3A3',
    500: '#737373',
    600: '#525252',
    700: '#404040',
    800: '#262626',
    900: '#171717',
    A100: '#F5F5F5',
    A200: '#EEEEEE',
    A400: '#BDBDBD',
    A700: '#616161',
  },
  lime: {
    50: '#FDFDF0',
    100: '#F7F9E0',
    200: '#EEF4B3',
    300: '#E2EC82',
    400: '#D4E245',
    500: '#C8D805',
    600: '#AAB800',
    700: '#8D9700',
    800: '#727800',
    900: '#575C00',
    A100: '#F4FF81',
    A200: '#EEFF41',
    A400: '#C6FF00',
    A700: '#AEEA00',
  },
  orange: {
    50: '#FFF7ED',
    100: '#FFEDD5',
    200: '#FED7AA',
    300: '#FDBA74',
    400: '#FB923C',
    500: '#F97316',
    600: '#EA580C',
    700: '#C2410C',
    800: '#9A3412',
    900: '#7C2D12',
    A100: '#FFD180',
    A200: '#FFAB40',
    A400: '#FF9100',
    A700: '#FF6D00',
  },
  purple: {
    50: '#FAF5FF',
    100: '#F3E8FF',
    200: '#E9D5FF',
    300: '#D8B4FE',
    400: '#C084FC',
    500: '#A855F7',
    600: '#9333EA',
    700: '#7E22CE',
    800: '#6B21A8',
    900: '#581C87',
    A100: '#EA80FC',
    A200: '#E040FB',
    A400: '#D500F9',
    A700: '#AA00FF',
  },
  red: {
    50: '#FFF1F2',
    100: '#FFE4E6',
    200: '#FECDD3',
    300: '#FDA4AF',
    400: '#FB7185',
    500: '#F43F5E',
    600: '#E11D48',
    700: '#BE123C',
    800: '#9F1239',
    900: '#881337',
    A100: '#FF8A80',
    A200: '#FF5252',
    A400: '#FF1744',
    A700: '#D50000',
  },
  yellow: {
    50: '#FEFCE8',
    100: '#FEF9C3',
    200: '#FEF08A',
    300: '#FDE047',
    400: '#FACC15',
    500: '#EAB308',
    600: '#CA8A04',
    700: '#A16207',
    800: '#854D0E',
    900: '#713F12',
    A100: '#FFFF8D',
    A200: '#FFFF00',
    A400: '#FFEA00',
    A700: '#FFD600',
  },
} as const;

// Dark mode variants - inverted shades for better contrast in dark mode
export const darkExtendedColors = {
  deepPurple: {
    50: '#4c1d95',
    100: '#5b21b6',
    200: '#6d28d9',
    300: '#7c3aed',
    400: '#8b5cf6',
    500: '#a78bfa',
    600: '#c4b5fd',
    700: '#ddd6fe',
    800: '#ede9fe',
    900: '#f5f3ff',
    A100: '#6200ea',
    A200: '#651fff',
    A400: '#7c4dff',
    A700: '#b388ff',
  },
  indigo: {
    50: '#312e81',
    100: '#3730a3',
    200: '#4338ca',
    300: '#4f46e5',
    400: '#5b21b6',
    500: '#6d28d9',
    600: '#7c3aed',
    700: '#8b5cf6',
    800: '#a78bfa',
    900: '#c4b5fd',
    A100: '#304ffe',
    A200: '#3d5afe',
    A400: '#536dfe',
    A700: '#8c9eff',
  },
  lightBlue: {
    50: '#0c4a6e',
    100: '#075985',
    200: '#0369a1',
    300: '#0284c7',
    400: '#0ea5e9',
    500: '#38bdf8',
    600: '#7dd3fc',
    700: '#bae6fd',
    800: '#e0f2fe',
    900: '#f0f9ff',
    A100: '#0091ea',
    A200: '#00b0ff',
    A400: '#40c4ff',
    A700: '#80d8ff',
  },
  cyan: {
    50: '#164e63',
    100: '#155e75',
    200: '#0e7490',
    300: '#0891b2',
    400: '#06b6d4',
    500: '#22d3ee',
    600: '#67e8f9',
    700: '#a5f3fc',
    800: '#cffafe',
    900: '#ecfeff',
    A100: '#0891b2',
    A200: '#06b6d4',
    A400: '#22d3ee',
    A700: '#67e8f9',
  },
  teal: {
    50: '#134e4a',
    100: '#115e59',
    200: '#0f766e',
    300: '#0d9488',
    400: '#14b8a6',
    500: '#2dd4bf',
    600: '#5eead4',
    700: '#99f6e4',
    800: '#ccfbf1',
    900: '#f0fdfa',
    A100: '#0d9488',
    A200: '#14b8a6',
    A400: '#2dd4bf',
    A700: '#5eead4',
  },
  lightGreen: {
    50: '#365314',
    100: '#4d7c0f',
    200: '#65a30d',
    300: '#84cc16',
    400: '#a3e635',
    500: '#bef264',
    600: '#d9f99d',
    700: '#ecfccb',
    800: '#f7fee7',
    900: '#f7fee7',
    A100: '#65a30d',
    A200: '#84cc16',
    A400: '#a3e635',
    A700: '#bef264',
  },
  amber: {
    50: '#78350f',
    100: '#92400e',
    200: '#b45309',
    300: '#d97706',
    400: '#fbbf24',
    500: '#fcd34d',
    600: '#fde68a',
    700: '#fef3c7',
    800: '#fffbeb',
    900: '#fffbeb',
    A100: '#f59e0b',
    A200: '#fbbf24',
    A400: '#fcd34d',
    A700: '#d97706',
  },
  deepOrange: {
    50: '#96240d',
    100: '#b82d11',
    200: '#d93815',
    300: '#f44819',
    400: '#ff5722',
    500: '#ff7043',
    600: '#ff8a65',
    700: '#ffab91',
    800: '#ffccbc',
    900: '#fbe9e7',
    A100: '#ff9f8d',
    A200: '#ff7a61',
    A400: '#ff4f1f',
    A700: '#f43600',
  },
  brown: {
    50: '#482718',
    100: '#5d3726',
    200: '#744937',
    300: '#8f5e4a',
    400: '#ab7761',
    500: '#c49881',
    600: '#e8d2c5',
    700: '#f5e9e2',
    800: '#fbf5f1',
    900: '#fbf5f1',
    A100: '#d7b7a3',
    A200: '#c49881',
    A400: '#ab7761',
    A700: '#8f5e4a',
  },
  blueGrey: {
    50: '#0f172a',
    100: '#1e293b',
    200: '#334155',
    300: '#475569',
    400: '#64748b',
    500: '#94a3b8',
    600: '#cbd5e1',
    700: '#e2e8f0',
    800: '#f1f5f9',
    900: '#f8fafc',
    A100: '#475569',
    A200: '#64748b',
    A400: '#94a3b8',
    A700: '#cbd5e1',
  },
  pink: {
    50: '#831843',
    100: '#9D174D',
    200: '#BE185D',
    300: '#DB2777',
    400: '#EC4899',
    500: '#F472B6',
    600: '#F9A8D4',
    700: '#FBCFE8',
    800: '#FCE7F3',
    900: '#FDF2F8',
    A100: '#C51162',
    A200: '#F50057',
    A400: '#FF4081',
    A700: '#FF80AB',
  },
  blue: {
    50: '#1E3A8A',
    100: '#1E40AF',
    200: '#1D4ED8',
    300: '#2563EB',
    400: '#3B82F6',
    500: '#60A5FA',
    600: '#93C5FD',
    700: '#BFDBFE',
    800: '#DBEAFE',
    900: '#EFF6FF',
    A100: '#2962FF',
    A200: '#2979FF',
    A400: '#448AFF',
    A700: '#82B1FF',
  },
  green: {
    50: '#14532D',
    100: '#166534',
    200: '#15803D',
    300: '#16A34A',
    400: '#22C55E',
    500: '#4ADE80',
    600: '#86EFAC',
    700: '#BBF7D0',
    800: '#DCFCE7',
    900: '#F0FDF4',
    A100: '#00C853',
    A200: '#00E676',
    A400: '#69F0AE',
    A700: '#B9F6CA',
  },
  grey: {
    50: '#171717',
    100: '#262626',
    200: '#404040',
    300: '#525252',
    400: '#737373',
    500: '#A3A3A3',
    600: '#D4D4D4',
    700: '#E5E5E5',
    800: '#F5F5F5',
    900: '#FAFAFA',
    A100: '#616161',
    A200: '#BDBDBD',
    A400: '#EEEEEE',
    A700: '#F5F5F5',
  },
  lime: {
    50: '#575C00',
    100: '#727800',
    200: '#8D9700',
    300: '#AAB800',
    400: '#C8D805',
    500: '#D4E245',
    600: '#E2EC82',
    700: '#EEF4B3',
    800: '#F7F9E0',
    900: '#FDFDF0',
    A100: '#AEEA00',
    A200: '#C6FF00',
    A400: '#EEFF41',
    A700: '#F4FF81',
  },
  orange: {
    50: '#7C2D12',
    100: '#9A3412',
    200: '#C2410C',
    300: '#EA580C',
    400: '#F97316',
    500: '#FB923C',
    600: '#FDBA74',
    700: '#FED7AA',
    800: '#FFEDD5',
    900: '#FFF7ED',
    A100: '#FF6D00',
    A200: '#FF9100',
    A400: '#FFAB40',
    A700: '#FFD180',
  },
  purple: {
    50: '#581C87',
    100: '#6B21A8',
    200: '#7E22CE',
    300: '#9333EA',
    400: '#A855F7',
    500: '#C084FC',
    600: '#D8B4FE',
    700: '#E9D5FF',
    800: '#F3E8FF',
    900: '#FAF5FF',
    A100: '#AA00FF',
    A200: '#D500F9',
    A400: '#E040FB',
    A700: '#EA80FC',
  },
  red: {
    50: '#881337',
    100: '#9F1239',
    200: '#BE123C',
    300: '#E11D48',
    400: '#F43F5E',
    500: '#FB7185',
    600: '#FDA4AF',
    700: '#FECDD3',
    800: '#FFE4E6',
    900: '#FFF1F2',
    A100: '#D50000',
    A200: '#FF1744',
    A400: '#FF5252',
    A700: '#FF8A80',
  },
  yellow: {
    50: '#713F12',
    100: '#854D0E',
    200: '#A16207',
    300: '#CA8A04',
    400: '#EAB308',
    500: '#FACC15',
    600: '#FDE047',
    700: '#FEF08A',
    800: '#FEF9C3',
    900: '#FEFCE8',
    A100: '#FFD600',
    A200: '#FFEA00',
    A400: '#FFFF00',
    A700: '#FFFF8D',
  },
} as const;
